export default "__VITE_ASSET__NAGD3Z_5__"